import React, { useState, useEffect } from "react";
import { Menu, Dropdown } from "antd";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";
import "./MenuBar.css";
import useAuth from "../hooks/useAuth";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrganisationItemAsync, selectOrganisation } from "../features/organisations/organisationsSlice";

const items = [
  {
    label: <Link to="/">Home</Link>,
    key: "home",
    authOnly: false,
  },
  {
    label: <Link to="/news">News</Link>,
    key: "news",
    authOnly: true,
  },
  {
    label: <Link to="/courses">My Courses</Link>,
    key: "courses",
    authOnly: true,
  },
  {
    label: <Link to="/documents">Documents</Link>,
    key: "documents",
    authOnly: true,
  },
  {
    label: <Link to="/driver-duties">Driver Duties</Link>,
    key: "driver-duties",
    authOnly: true,
  },
  {
    label: <Link to="/services">Services</Link>,
    key: "services",
    authOnly: true,
  },
  {
    label: <Link to="/journey-planner">Journey Planner</Link>,
    key: "journey-planner",
    authOnly: true,
  },
  {
    label: <Link to="/bookings">Bookings</Link>,
    key: "bookings",
    authOnly: true,
  },
  {
    label: <Link to="/shop/courses">Shop</Link>,
    key: "shop",
    authOnly: true,
  },
];

export default function MenuBar() {
  const { auth } = useAuth();
  const dispatch = useDispatch();
  const [current, setCurrent] = useState("dashboard");
  const [menuMode, setMenuMode] = useState();
  const [menuVisible, setMenuVisible] = useState();
  const [filteredItems, setFilteredItems] = useState([]);
  const organisationData = useSelector(selectOrganisation);
  const org = useSelector((state) => state.organisation.organisation);
  const manualApprovalEnabled = org?.attributes?.LMS.enable_manual_approval;
  const isUserConfirmed = manualApprovalEnabled ? auth.getUser().confirmed && auth.getUser().isUserApproved : true;
  const isDriver = auth.getUser().membertype === "Driver";

  useEffect(() => {
    if (!organisationData) {
      dispatch(fetchOrganisationItemAsync());
    }
  }, [auth, dispatch, organisationData]);

  useEffect(() => {
    const isLoggedIn = auth.isLoggedIn();
    if (filteredItems.length === 0 && !!organisationData) {
      const stripeSetupComplete = !!organisationData.attributes?.stripe?.accountId;

      setFilteredItems(
        items
          .filter((item) => {
            if (item.authOnly) {
              if (item.key === "news") {
                return organisationData.attributes.LMS.show_news && isLoggedIn && isUserConfirmed;
              }
              if (item.key === "courses") {
                // show_courses might be undefined only hide it if its false
                return organisationData.attributes.LMS.show_courses !== false && isLoggedIn && isUserConfirmed;
              }
              if (item.key === "shiftbats" || item.key === "driver-duties") {
                return organisationData.attributes.LMS.show_shiftbats && isLoggedIn && isUserConfirmed && isDriver;
              }
              if (item.key === "services") {
                return organisationData.attributes.LMS.show_services && isLoggedIn && isUserConfirmed && isDriver;
              }
              if (item.key === "journey-planner") {
                return organisationData.attributes.LMS.show_journey_planner && isLoggedIn && isUserConfirmed;
              }
              if (item.key === "documents") {
                return organisationData.attributes.LMS.show_documents && isLoggedIn && isUserConfirmed;
              }
              if (item.key === "bookings") {
                return organisationData.attributes.LMS.show_booking_form && isLoggedIn && isUserConfirmed;
              }
              if (item.key === "shop") {
                return organisationData.attributes.LMS.show_shop && stripeSetupComplete && isLoggedIn && isUserConfirmed;
              }

              return isLoggedIn;
            }
            return true;
          })
          ?.map(({ authOnly, ...item }) => item)
      );
    }
  }, [auth, filteredItems.length, organisationData, isUserConfirmed]);

  const onClick = (e) => {
    setCurrent(e.key);
  };
  const showMainMenu = () => {
    return <Menu onClick={onClick} selectedKeys={[current]} mode="horizontal" items={filteredItems} />;
  };
  useEffect(() => {
    const checkWindowSize = () => {
      if (window.innerWidth > 992) {
        setMenuMode("horizontal");
      } else {
        setMenuMode("inline");
      }
    };

    window.addEventListener("resize", checkWindowSize);
    checkWindowSize();
    return () => window.removeEventListener("resize", checkWindowSize);
  }, []);
  return (
    <div className="MenuBar">
      {menuMode === "inline" ? (
        <Dropdown menu={{ items: filteredItems }} open={menuVisible} trigger={["click"]} overlayClassName="AppMenuDrop">
          <div
            className="ant-dropdown-link"
            onClick={(e) => {
              e.preventDefault();
              setMenuVisible(!menuVisible);
            }}
          >
            <MenuOutlined />
          </div>
        </Dropdown>
      ) : (
        showMainMenu()
      )}
    </div>
  );
}
